import { Breadcrumbs, Stack, Typography, Tabs, Tab } from '@mui/material'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useMatch, Link } from 'react-router-dom'

import PageContainer from 'components/common/PageContainer'
import PageSection from 'components/common/PageSection'
import Icon from 'components/Icon'
import { Header } from 'components/navigation/Header'
import useAuth from 'hooks/use-auth'
import { useHasServices } from 'hooks/use-has-services'
import { muiTheme } from 'mui-theme'
import { servicesGet } from 'utils/endpoints-access'

const iconStyles = { marginRight: muiTheme.spacing(0.5) }

export const enum HOME_PATHS {
  TeamReliability = '/team-reliability',
  GettingStarted = '/getting-started'
}

const pathToTab = {
  [HOME_PATHS.TeamReliability]: 0,
  [HOME_PATHS.GettingStarted]: 1
}

const tabs = [
  { label: 'TEAM RELIABILITY', path: HOME_PATHS.TeamReliability },
  { label: 'GETTING STARTED', path: HOME_PATHS.GettingStarted }
]

export const HomeLayoutWrapper: React.FC = ({ children }) => {
  const { currentTeamId, hasEndpointAccess } = useAuth()
  const canGetServices = hasEndpointAccess(servicesGet, {
    teamId: currentTeamId
  })
  const { hasServices, isServicesError, isServicesLoading } = useHasServices({
    enabled: canGetServices
  })

  const { params } = useMatch('/:path/*') ?? {}
  const { path } = params ?? {}

  const currentPath = `/${path}` as keyof typeof pathToTab
  const tab = currentPath in pathToTab ? pathToTab[currentPath] : 0

  return (
    <>
      <Helmet title="Home" />
      <Header>
        <Breadcrumbs aria-label="breadcrumb">
          <Stack alignItems="center" direction="row">
            <Icon css={iconStyles} icon="house" />{' '}
            <Typography color="text.primary">Home</Typography>
          </Stack>
        </Breadcrumbs>
      </Header>
      <PageContainer>
        <PageSection
          errorMessage="We were unable to load your services. Please try again later."
          hasError={isServicesError}
          isLoading={isServicesLoading}
          isLoadingOverlayFullScreen={false}
        >
          {canGetServices && hasServices && (
            <Tabs value={tab}>
              {tabs.map((tabItem) => (
                <Tab
                  key={tabItem.path}
                  component={Link}
                  label={tabItem.label}
                  sx={{ textTransform: 'uppercase' }}
                  to={tabItem.path}
                />
              ))}
            </Tabs>
          )}
          {children}
        </PageSection>
      </PageContainer>
    </>
  )
}
